module.exports = __webpack_public_path__ + "img/Brand_explore_three.6d62b874.png";